import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { Link } from '@s20/components/common/Link';
import { UncontrolledCollapseUnderlineHeader, SimpleTable } from '../common/forms/FormElements';
import CommonContext, { ApiRoutes, ApplicationPermissions, AppNavPaths } from '../Common';

export const ProjectInvoices = ({ projectId }) => {
    const context = useContext(CommonContext);
    const canViewInvoices = context.checkUserHasPermission(ApplicationPermissions.invoice_view);

    const { data: invoices, isLoading } = useQuery({
        queryKey: ['projectInvoices', projectId],
        queryFn: () => httpClient.js(ApiRoutes.project.invoices(projectId)),
        enabled: Boolean(projectId) && canViewInvoices,
    });

    if (!projectId || !canViewInvoices) {
        return null;
    }

    const { tenantSettings } = context.tenant;
    const projectInvoices = invoices ?? [];

    return (
        <div className="mt-3 mb-3">
            <UncontrolledCollapseUnderlineHeader
                headerText="Invoices"
                defaultIsOpen={false}
            >
                <SimpleTable
                    permission="invoice"
                    tableHeaderLabels={[
                        { name: 'Invoice Date', width: '180px' },
                        { name: 'Invoice Number' },
                    ]}
                    entities={projectInvoices}
                    noDataText={isLoading ? 'Loading invoices...' : 'No invoices found.'}
                    rowRenderer={() => projectInvoices.map((invoice) => (
                        <tr key={invoice.id}>
                            <td>
                                {invoice.invoiceDate
                                    ? moment(invoice.invoiceDate).format('MM/DD/YYYY')
                                    : '--'}
                            </td>
                            <td>
                                <Link
                                    className="site-link"
                                    to={`${invoice.isRentalInvoice
                                        && !tenantSettings.combineRentalNonRentalChargesOnRentalInvoices
                                        ? AppNavPaths.RentalInvoice
                                        : AppNavPaths.Invoice}?iId=${invoice.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {invoice.invoiceNumber}
                                    <FontAwesomeIcon
                                        icon={faArrowUpRightFromSquare}
                                        size="sm"
                                        className="ml-1"
                                    />
                                </Link>
                            </td>
                        </tr>
                    ))}
                />
            </UncontrolledCollapseUnderlineHeader>
        </div>
    );
};

export default ProjectInvoices;
